import request from '@/utils/request';

export function gethomeinfo(data) {
  return request({
    url: '/public/v1/home',
    method: 'get',
    params: data,
  })
}

export function getnotice(data) {
  return request({
    url: '/public/v1/notice',
    method: 'get',
    params: data,
  })
}

export function getnoticeOne(id) {
  return request({
    url: '/public/v1/notice/' + id,
    method: 'get',
  })
}

export function getusermsm(data) {
  return request({
    url: '/api/v1/wxappverification',
    method: 'put',
    data: data,
  })
}

export function changeuserinfo(data) {
  return request({
    url: '/api/v1/userinfo',
    method: 'put',
    data: data,
  })
}

export function getcourselist() {
  return request({
    url: '/user/v1/course',
    method: 'get',
  })
}

export function getpaper(id, data) {
  return request({
    url: '/user/v1/paper/' + id,
    method: 'get',
    params: data,
  })
}

export function getpaperinfo(data) {
  return request({
    url: '/user/v1/paper/info',
    method: 'get',
    params: data,
  })
}

export function changepaper(id, data) {
  return request({
    url: '/user/v1/paper/' + id,
    method: 'put',
    data: data,
  })
}

export function getexam(data) {
  return request({
    url: '/user/v1/exam',
    method: 'get',
    params: data,
  })
}

export function getcertificate() {
  return request({
    url: '/user/v1/certificate',
    method: 'get',
  })
}

export function getnew_certificat() {
  return request({
    url: '/user/v1/new_certificat',
    method: 'get',
  })
}

export function getnew_certificatOne(data) {
  return request({
    url: '/user/v1/new_certificat/' + data,
    method: 'get',
  })
}

export function deletenew_certificat(data) {
  return request({
    url: '/user/v1/new_certificat/' + data,
    method: 'delete',
  })
}

export function addnew_certificat(data) {
  return request({
    url: '/user/v1/new_certificat',
    method: 'POST',
    data: data
  })
}

export function getcertificateOne(id) {
  return request({
    url: '/user/v1/certificate/' + id,
    method: 'get',
  })
}

export function getcertificateapply(id) {
  return request({
    url: '/user/v1/certificate/' + id + '/apply',
    method: 'get',
  })
}
export function gettbsurveysubmit(data) {
  return request({
    url: '/user/v1/tbsurveysubmit',
    method: 'get',
    params: data,
  })
}

export function gettbsurveysubmitOne(data) {
  return request({
    url: '/user/v1/tbsurveysubmit/' + data,
    method: 'get',
  })
}

export function submittbsurveysubmit(data) {
  return request({
    url: '/user/v1/tbsurveysubmit',
    method: 'post',
    data: data,
  })
}

export function getapplytpl() {
  return request({
    url: '/user/v1/applytpl',
    method: 'get',
  })
}

export function createActive(data) {
  return request({
    url: '/user/v1/statistics/createActive',
    method: 'post',
    data: data,
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js